import { createFileRoute, } from '@tanstack/react-router';
import { api, } from '../../../../../../api/Api.js';
/** @deprecated TODO: 326 remove in 30 days after release  */
export const Route = createFileRoute('/client/invoice/download/$token')({
    // prevent re-requesting tan on language switch
    shouldReload: false,
    async loader({ params }) {
        return await api.client.invoice.requestTan.request({
            token: params.token,
        });
    },
});
//# sourceMappingURL=ClientInvoiceDownloadTokenRoute.js.map